// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__16esS","label":"Radio_label__1oC55","checkMark":"Radio_checkMark__x3Koq","disabled":"Radio_disabled__2taGG"};